import type React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUser } from '../utils';
import { PATH } from './PATH';

/**
 * Role gate for the management shell. Sits inside `SecuredRoutes` (so the user is
 * already enrolled + signed in). Only a `BranchAdmin` belongs here; a `Seller`
 * is sent back to the POS to sell.
 */
export const ManageRoute: React.FC = () => {
    if (getUser()?.role !== 'BranchAdmin') {
        return <Navigate replace to={PATH.SELLER} />;
    }
    return <Outlet />;
};
